import { iRequest } from '../../utils/requestutil';

export async function query(payload) {
  return iRequest(`/iwms-basic/basic/dc/list/company?companyUuid=${payload.companyUuid}`, {
    method: 'get',
  });
}
